module.exports = __webpack_public_path__ + "static/media/23000078_1638434632898388_2410376782712564363_o-thumb.dd264439.jpg";